import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/location.png'
import _imports_1 from '@/assets/images/line.png'


const _withScopeId = n => (_pushScopeId("data-v-2c1db5ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "financialservice" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "adv" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "金融服务"),
  /*#__PURE__*/_createElementVNode("i", { class: "sub" }, "FINANCIAL SERVICE")
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "path" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "location",
    src: _imports_0,
    alt: "",
    srcset: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "label" }, "当前位置:"),
  /*#__PURE__*/_createElementVNode("span", null, "首页 > 金融服务")
], -1))
const _hoisted_5 = { class: "flex gap-[40px] bg-white p-[60px]" }
const _hoisted_6 = { class: "w-[220px] bg-[#F5F5F5]" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w-full h-[70px] text-[22px] inline-flex justify-center items-center font-bold text-[#fff] bg-[#333]" }, " 金融服务", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-daezijin mr-[5px]" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_10 = { class: "title text-[20px] mb-[10px]" }
const _hoisted_11 = { class: "text-[16px] mb-[20px]" }
const _hoisted_12 = { class: "flex justify-center mt-[20px]" }
const _hoisted_13 = {
  key: 1,
  class: "relative flex-1 py-[30px] px-[40px]"
}
const _hoisted_14 = { class: "text-[26px] text-[#333] mb-[10px] text-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative text-center mb-[20px]" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xiangxiajiantou1" }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "absolute bottom-[10px] left-[19.5%] w-[450px] inline-block",
    src: _imports_1,
    alt: "",
    srcset: ""
  })
], -1))
const _hoisted_16 = ["innerHTML"]

import { ref, onMounted, onUnmounted } from "vue";
import {
    Back,
    ArrowRight,
} from '@element-plus/icons-vue';
import { getLeaf, getPage } from "@/http/api/index";
import useGetContext from "@/hooks/useGetContext";
import { IList, IItem } from '@/interface/article.d';


export default /*#__PURE__*/_defineComponent({
  __name: 'financialService',
  setup(__props) {

const { proxy, getMenuId } = useGetContext();

const sidebarList = ref<IList[]>([]);

const modelName = ref('list');

const articleList = ref<Array<IItem>>([]);

const articleListTotal = ref<Array<IItem>>([]);

const activeIndex = ref();

const articleDetial = ref<Partial<IItem>>({})

const handleOpen = (key: string, keyPath: string[]) => {
    console.log(key, keyPath)
}
const handleClose = (key: string, keyPath: string[]) => {
    console.log(key, keyPath)
}

const handleClick = (item: IItem) => {
    getSelPage(item.id, 1);
    modelName.value = 'list';
}

const handleForwardDetail = (item) => {
    modelName.value = 'detail';
    articleDetial.value = item;

}
const handleBack = () => {
    modelName.value = 'list';
}

function getNewsInfo() {
    const { newMenu } = getMenuId("/financial") || {};
    getLeaf({ menuId: newMenu.id }).then((res: any) => {
        sidebarList.value = res.data.leftList;
        const id = res.data.leftList[0]?.leftList?.[0].id;
        getSelPage(id, 1);
        activeIndex.value = id;
    });
}
onMounted(() => {
    const { newMenu } = getMenuId("/financial") || {};
    if(newMenu?.id) {
        getNewsInfo();
    } else {
        proxy.$eventBus.on("navMenuInit", getNewsInfo);
    }
});
onUnmounted(() => {
    proxy.$eventBus.off("navMenuInit", getNewsInfo);
});
const getSelPage = (menuId, pageNum) => {
    getPage({
        menuId,
        pageNum,
        pageSize: 20,
    }).then((res: any) => {
        if(res.code === 200) {
            articleList.value = res.rows;
            articleListTotal.value = res.total;
        }
    });
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_menu, {
            "default-active": activeIndex.value,
            class: "el-menu-vertical-demo",
            onOpen: handleOpen,
            onClose: handleClose
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sidebarList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_sub_menu, {
                  index: item.id,
                  key: item.id
                }, {
                  title: _withCtx(() => [
                    _hoisted_8,
                    _createElementVNode("span", null, _toDisplayString(item.title), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.leftList, (v) => {
                      return (_openBlock(), _createBlock(_component_el_menu_item, {
                        key: v.id,
                        index: v.id,
                        onClick: ($event: any) => (handleClick(v))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(v.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["index", "onClick"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["index"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["default-active"])
        ]),
        (modelName.value === 'list')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item py-[30px] px-[40px] border-[#DEDEDE] border-b",
                  key: item.id
                }, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(item.title), 1),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(item.digest), 1),
                  _createVNode(_component_el_button, {
                    class: "btn h-[40px]",
                    onClick: ($event: any) => (handleForwardDetail(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 查看详情"),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ArrowRight))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_pagination, {
                  background: "",
                  layout: "prev, pager, next",
                  total: articleListTotal.value
                }, null, 8, ["total"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_el_icon, {
                class: "absolute left-[30px] top-[5px] text-[28px] hover:cursor-pointer",
                onClick: handleBack
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Back))
                ]),
                _: 1
              }),
              _createElementVNode("p", _hoisted_14, _toDisplayString(articleDetial.value.title), 1),
              _hoisted_15,
              _createElementVNode("p", {
                class: "text-[16px] text-[#333] leading-[1.8] indent-[2em]",
                innerHTML: articleDetial.value.content
              }, null, 8, _hoisted_16)
            ]))
      ])
    ])
  ]))
}
}

})